import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import cookieImage from '../../assets/backgrounds/cookie.png';
import './styles.css';

const CookiePolicy = () => {
  useEffect(() => {
    document.body.classList.add('cookie-policy-page');
    return () => {
      document.body.classList.remove('cookie-policy-page');
    };
  }, []);

  return (
    <section className="cookie-section">
      <div className="cookie-hero">
        <img src={cookieImage} alt="Política de Cookies" />
        <div className="hero-content">
          <h1>Política de Cookies</h1>
          <p>Entenda como utilizamos cookies para melhorar sua experiência</p>
        </div>
      </div>
      
      <div className="cookie-container">
        <div className="cookie-content">
          <div className="cookie-index">
            <h2>Índice</h2>
            <ul className="index-list">
              <li><a href="#introducao"><span>1.</span> Introdução</a></li>
              <li><a href="#o-que-sao"><span>2.</span> O que são Cookies</a></li>
              <li><a href="#tipos"><span>3.</span> Tipos de Cookies</a></li>
              <li><a href="#como-usamos"><span>4.</span> Como Usamos</a></li>
              <li><a href="#gerenciamento"><span>5.</span> Gerenciamento de Cookies</a></li>
              <li><a href="#terceiros"><span>6.</span> Cookies de Terceiros</a></li>
              <li><a href="#atualizacoes"><span>7.</span> Atualizações</a></li>
              <li><a href="#contato"><span>8.</span> Contato</a></li>
            </ul>
          </div>

          <section id="introducao" className="policy-section">
            <h2>1. Introdução</h2>
            <p>A JoviPlanet utiliza cookies e tecnologias semelhantes para fornecer, proteger e melhorar os nossos serviços. Esta política explica como e por que usamos essas tecnologias e as escolhas que você tem.</p>
            <div className="highlight-box">
              <p>Esta política é parte integrante da nossa Política de Privacidade e aplica-se a todos os usuários da plataforma JoviPlanet.</p>
            </div>
          </section>

          <section id="o-que-sao" className="policy-section">
            <h2>2. O que são Cookies</h2>
            <p>Cookies são pequenos arquivos de texto que são armazenados no seu dispositivo quando você visita um site. Eles servem para registar as suas preferências e melhorar a sua experiência online.</p>
            <h3>Principais funções:</h3>
            <ul>
              <li>Para registrar as suas preferências e configurações</li>
              <li>Manter a sua sessão ativa</li>
              <li>Entender como você usa o nosso site</li>
              <li>Melhorar a segurança</li>
            </ul>
          </section>

          <section id="tipos" className="policy-section">
            <h2>3. Tipos de Cookies</h2>
            <h3>3.1 Cookies Essenciais</h3>
            <p>São necessários para o funcionamento básico do site:</p>
            <ul>
              <li>Autenticação e segurança</li>
              <li>Funcionalidades básicas</li>
              <li>Registro de itens no seu carrinho</li>
            </ul>

            <h3>3.2 Cookies de Preferências</h3>
            <p>Permitem que o site registre as suas escolhas:</p>
            <ul>
              <li>Idioma preferido</li>
              <li>Região e fuso horário</li>
              <li>Configurações de visualização</li>
            </ul>

            <h3>3.3 Cookies Analíticos</h3>
            <p>Ajudam-nos a entender como os usuários interagem com o site:</p>
            <ul>
              <li>Páginas mais visitadas</li>
              <li>Erros encontrados</li>
              <li>Como você chegou até nós</li>
            </ul>
          </section>

          <section id="como-usamos" className="policy-section">
            <h2>4. Como Usamos</h2>
            <p>Utilizamos os cookies para diversos fins:</p>
            <ul>
              <li>Melhorar a navegação e a experiência do usuário</li>
              <li>Analisar o desempenho do site</li>
              <li>Personalizar conteúdo e anúncios</li>
              <li>Proteger contra atividades fraudulentas</li>
            </ul>
            <div className="highlight-box">
              <p>Importante: Você pode optar por não aceitar cookies não essenciais a qualquer momento.</p>
            </div>
          </section>

          <section id="gerenciamento" className="policy-section">
            <h2>5. Gerenciamento de Cookies</h2>
            <p>Você tem controle sobre os cookies no seu navegador:</p>
            <ul>
              <li>Configurar o seu navegador para aceitar ou rejeitar cookies</li>
              <li>Excluir cookies existentes</li>
              <li>Configurar notificações para novos cookies</li>
            </ul>
            <div className="highlight-box">
              <p>Atenção: Desabilitar cookies essenciais pode afetar o funcionamento do site.</p>
            </div>
          </section>

          <section id="terceiros" className="policy-section">
            <h2>6. Cookies de Terceiros</h2>
            <p>Alguns cookies são definidos por serviços de terceiros que aparecem nas nossas páginas:</p>
            <ul>
              <li>Serviços de análise (Google Analytics)</li>
              <li>Redes sociais (Facebook, Twitter)</li>
              <li>Serviços de pagamento</li>
              <li>Provedores de mapas</li>
            </ul>
          </section>

          <section id="atualizacoes" className="policy-section">
            <h2>7. Atualizações da Política</h2>
            <p>Podemos atualizar esta política periodicamente para refletir alterações nas nossas práticas ou por outros motivos operacionais, legais ou regulatórios.</p>
          </section>

          <section id="contato" className="policy-section">
            <h2>8. Contato</h2>
            <p>Se você tiver dúvidas sobre a nossa política de cookies, entre em contato:</p>
            <div className="highlight-box">
              <Link to="/contact" className="contact-button">
                Acessar formulário de contato
              </Link>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default CookiePolicy;